import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const UserCircleIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M9.99979 12.2687C12.021 12.2687 13.6595 10.6302 13.6595 8.60898C13.6595 6.58775 12.021 4.94922 9.99979 4.94922C7.97856 4.94922 6.34003 6.58775 6.34003 8.60898C6.34003 10.6302 7.97856 12.2687 9.99979 12.2687Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      fill="none"
    />

    <path
      d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02945 14.9706 1 10 1C5.02945 1 1 5.02945 1 10C1 14.9706 5.02945 19 10 19Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      fill="none"
    />

    <path
      d="M15.7603 16.8996C15.1815 16.4234 13.1275 14.8643 10.0653 14.8363C6.91903 14.8083 4.79039 16.4328 4.23022 16.8996"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      fill="none"
    />
  </SvgIcon>
);
